import React from "react";

import { DEFAULT_CARD_HEIGHT, TAG } from "config/constants";
import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import PromoStreamCap from "stream/components/PromoStreamCap";
import Helmet from "react-helmet-async";
import AxiosVisualsStreamCap from "stream/components/AxiosVisualsStreamCap";

import image from "assets/img/retail-deep-dive.png";
import ogImage from "assets/img/retail-deep-dive-social.jpg";

export default function FutureOfRetailTagStream() {
  const StreamShoe = () => (
    <AxiosVisualsStreamCap slug="2019-01-11-retail-deep-dive-module" />
  );

  return (
    <React.Fragment>
      <Helmet>
        <meta property="og:image" content={ogImage} />
      </Helmet>
      <TagStreamWrapper slug={TAG.FUTURE_OF_RETAIL.slug}>
        {({ streamParams }) => (
          <React.Fragment>
            <PromoStreamCap
              promo={{
                title: "The battle to get shoppers out of the house",
                content: (
                  <span>
                    Read our full report below and{" "}
                    <a
                      className="gtm-promo-stream-cap-content-link"
                      href="https://signup.axios.com/2019/am.html?source=axios&medium=referral&campaign=stream_cap_promo_link&page=axios"
                    >
                      sign up for Axios AM{" "}
                    </a>
                    to get deep dives into the biggest topics impacting the
                    future.
                  </span>
                ),
                contentForAnalytics:
                  "Read our full report below and sign up for Axios AM to get deep dives into the biggest topics impacting the future.",
                image: image,
              }}
            />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              streamShoeComponent={StreamShoe}
            />
          </React.Fragment>
        )}
      </TagStreamWrapper>
    </React.Fragment>
  );
}
